
export class User {
    public isLoggedIn : boolean = false;
    public userName: string = "Anonymous";
    public toString() : string {
        return `user "${this.userName}"`;
    }
}